import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postReceiptConfig } from "apis";

const usePostReceiptConfig = ({
  doctor_oid,
  clinic_id,
}: {
  doctor_oid: string;
  clinic_id: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation(postReceiptConfig, {
    onSuccess: () =>
      queryClient.invalidateQueries([`get-receipt-${doctor_oid}-${clinic_id}`]),
  });
};

export default usePostReceiptConfig;
